/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

const FacebookSiteContext = createContext({});
export default FacebookSiteContext;
